import { useState } from 'react';
import { renderToString } from 'react-dom/server';
import { useSelector } from 'react-redux';
import { selectCurrentOrder } from 'Redux/Order/slice';
import { selectOrderLoading } from 'Redux/Order/slice';
import { Alert, Spin } from 'antd';
import { MapContainer, TileLayer, Marker, ZoomControl } from 'react-leaflet';
import { FullscreenControl } from 'react-leaflet-fullscreen';
import L from 'leaflet';
import {
  parseCoordinate,
  getMiddleCoordinatesPoint,
  getZoomLvlByCoords,
} from 'Shared/Utils';
import 'leaflet/dist/leaflet.css';
import 'react-leaflet-fullscreen/styles.css';
import styles from './Map.module.scss';

export const Map = () => {
  const currentLoad = useSelector(selectCurrentOrder);
  const loadIsLoading = useSelector(selectOrderLoading);
  const [hue, setHue] = useState(216);
  const color = `hsl(${hue % 360}, 60%, 50%)`;

  const handleMarkerClick = () => {
    setHue(hue + 20);
  };

  const createCustomIcon = ({
    color,
    className,
  }: {
    color: string;
    className: string;
  }) => {
    const CustomIcon = (
      <div
        className={className}
        style={{
          backgroundColor: color,
        }}
      />
    );

    return L.divIcon({
      className: '',
      html: renderToString(CustomIcon),
    });
  };

  return (
    <div className={styles.map}>
      {currentLoad &&
      currentLoad.coordinate_from &&
      currentLoad.coordinate_to ? (
        <MapContainer
          center={getMiddleCoordinatesPoint(
            currentLoad.coordinate_from,
            currentLoad.coordinate_to,
          )}
          zoom={getZoomLvlByCoords(
            currentLoad.coordinate_from,
            currentLoad.coordinate_to,
          )}
          minZoom={3}
          zoomControl={false}
          className={styles.map__container}
        >
          <TileLayer
            url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
            attribution='&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors'
          />
          <Marker
            position={parseCoordinate(currentLoad.coordinate_from)}
            icon={createCustomIcon({
              color,
              className: `${styles.map__point} ${styles.map__pointA}`,
            })}
            eventHandlers={{
              click: handleMarkerClick,
            }}
          />
          <Marker
            position={parseCoordinate(currentLoad.coordinate_to)}
            icon={createCustomIcon({
              color,
              className: `${styles.map__point} ${styles.map__pointB}`,
            })}
            eventHandlers={{
              click: handleMarkerClick,
            }}
          />
          <ZoomControl position="topright" />
          <FullscreenControl />
        </MapContainer>
      ) : loadIsLoading ? (
        <Spin size="large" />
      ) : (
        <Alert
          message="Internal error, not enough data to load the map."
          type="error"
        />
      )}
    </div>
  );
};
